import {Location, LocationBookingStats} from '../api/types';
import { Action, handleActions } from 'redux-actions';
import { allTenantDependentDataCleared } from '../action/authenticationEvents';
import {
    AllAssetGroupFetchedPayload,
    LocationAvailabilitiesFetchedPayload,
    LocationUpdatedPayload,
    LocationsFetchedPayload,
    allAssetGroupsFetched,
    locationAvailabilitiesFetched, locationUpdated, locationsFetched,
} from '../action/locationsEvents';

export interface LocationsState {
    locations: Location[];
    bookingStats: Record<number, LocationBookingStats>;
}

export const initialState: LocationsState = {
    locations: [],
    bookingStats: {},
};

/* eslint-disable max-len */
export const reducer = handleActions<LocationsState, any>(
    {
        [locationsFetched.toString()]: (state = initialState, action: Action<LocationsFetchedPayload>) => {
            if (!state) {
                return state;
            }

            return {
                ...state,
                locations: action.payload.locations,
            };
        },
        [locationUpdated.toString()]: (state = initialState, action: Action<LocationUpdatedPayload>) => {
            if (!state) {
                return state;
            }

            return {
                ...state,
                locations: state.locations.map(location => {
                    if (location.id !== action.payload.id) {
                        return location;
                    }

                    return {
                        ...location,
                        enabled: action.payload.enabled,
                        status: action.payload.status,
                    };
                }),
            };
        },
        [allAssetGroupsFetched.toString()]:
            (state, action: Action<AllAssetGroupFetchedPayload>): LocationsState => {
                return {
                    ...state,
                    locations: state.locations.map((location) => {
                        const assetGroups = action.payload.assetGroups.filter((assetGroup) => assetGroup.locationId === location.id);
                        return {
                            ...location,
                            assetGroups,
                        };
                    }),
                };
            },
        [allTenantDependentDataCleared.toString()]: (state = initialState, action: Action<{}>) => {
            return {
                ...initialState,
            };
        },
        [locationAvailabilitiesFetched.toString()]:
            (state, action: Action<LocationAvailabilitiesFetchedPayload>): LocationsState => {
                return {
                    ...state,
                    locations: state.locations.map((location) => {
                        if (location.id === action.payload.locationId) {
                            return {
                                ...location,
                                assetGroups: (location.assetGroups || []).map((assetGroup) => {
                                    if (assetGroup.id === action.payload.assetGroup.id) {
                                        return {
                                            ...assetGroup,
                                            availabilities: action.payload.assetGroup.availabilities,
                                        };
                                    }
                                    return assetGroup;
                                }),
                            };
                        }
                        return location;
                    }),
                };
            },
    },
    initialState,
);
